// extracted by mini-css-extract-plugin
export var mainContainer = "parking-reservation-module--mainContainer--fhPSP";
export var backToTopButton = "parking-reservation-module--backToTopButton--1tgLb";
export var reservationContainer = "parking-reservation-module--reservationContainer--3Sitv";
export var alertSection = "parking-reservation-module--alertSection--21hUM";
export var noticeText = "parking-reservation-module--noticeText--1upVi";
export var dialogDescription = "parking-reservation-module--dialogDescription--1QqSB";